import { useState } from "react";
import { Box, Button, Typography } from "@mui/material";
import toast from "react-hot-toast";
import Modal from "../Unknown/Modal";
import CustomPhoneInput from "../UI/PhoneInput";
import translate from "../../i18n/translate";
import { userApi } from "../../modules/services/userService";
import { isValidOtpPhone } from "../../common/otp";

type Props = {
  onClose: () => void;
};

// Mounted only while open, so the initial state is the reset
const OtpBypassModal = ({ onClose }: Props) => {
  const [phone, setPhone] = useState("+972");
  const [isPhoneInvalid, setIsPhoneInvalid] = useState(false);

  const [addPhone, { isLoading }] = userApi.useAddOtpBypassPhoneMutation();

  const onPhoneChange = (value: string) => {
    setPhone(value);
    setIsPhoneInvalid(false);
  };

  const onSubmit = async () => {
    const phoneDigits = phone.replace(/\D/g, "");

    if (!isValidOtpPhone(phoneDigits)) {
      setIsPhoneInvalid(true);
      return;
    }

    try {
      await addPhone(phoneDigits).unwrap();
      toast.success(translate("otpBypassAddSuccess"));
      onClose();
    } catch {
      toast.error(translate("otpBypassAddFailed"));
    }
  };

  return (
    <Modal title={translate("otpBypassAdd")} visible style={{ maxWidth: "500px" }} setVisible={onClose}>
      <Box my={2} p={2} display="flex" flexDirection="column" alignItems="center" width={1} gap={2}>
        <Box width={1}>
          <CustomPhoneInput phone={phone} setPhone={onPhoneChange} />
          {isPhoneInvalid && (
            <Typography variant="body2" color="error" mt={1}>
              {translate("otpPhoneInvalid")}
            </Typography>
          )}
        </Box>
        <Typography variant="body2" color="text.secondary" textAlign="center">
          {translate("otpBypassHint")}
        </Typography>
        <Button size="large" variant="contained" color="warning" onClick={onSubmit} disabled={isLoading}>
          {translate("otpBypassAdd")}
        </Button>
      </Box>
    </Modal>
  );
};

export default OtpBypassModal;
